import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const items = [
  {
    icon: '🏠', label: 'Home',   route: '/home',
    active: p => p === '/home',
  },
  {
    icon: '🔍', label: 'Search', route: '/search',
    active: p => p === '/search' || p === '/all-paths' || p.startsWith('/theme/'),
  },
  {
    icon: '📚', label: 'Words',  route: '/words',
    active: p => p === '/words',
  },
  {
    icon: '🔖', label: 'Saved',  route: '/saved',
    active: p => p === '/saved',
  },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [dueCount, setDueCount] = useState(() => {
    try { return parseInt(localStorage.getItem('diwanDueCount') ?? '0', 10) || 0; } catch { return 0; }
  });

  useEffect(() => {
    function onStorage(e) {
      if (e.key === 'diwanDueCount') {
        setDueCount(parseInt(e.newValue ?? '0', 10) || 0);
      }
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <nav className="bottom-nav" aria-label="Main navigation" style={{ flexDirection: 'column' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        {items.map(item => (
          <button
            key={item.label}
            aria-label={item.label}
            aria-current={item.active(pathname) ? 'page' : undefined}
            className={`bn-item${item.active(pathname) ? ' active' : ''}`}
            onClick={() => navigate(item.route)}
            style={{ position: 'relative' }}
          >
            <span className="bn-icon" aria-hidden="true">{item.icon}</span>
            {item.label === 'Words' && dueCount > 0 && (
              <span style={{
                position: 'absolute', top: 6, right: 'calc(50% - 14px)',
                background: '#f87171', color: '#fff',
                fontFamily: "'Josefin Sans', sans-serif",
                fontSize: '0.45rem', fontWeight: 700, lineHeight: 1,
                minWidth: 14, height: 14,
                borderRadius: 7,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '0 3px',
                pointerEvents: 'none',
              }}>
                {dueCount > 9 ? '9+' : dueCount}
              </span>
            )}
            <span className="bn-label">{item.label}</span>
          </button>
        ))}
      </div>
      <button
        onClick={() => navigate('/privacy')}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontFamily: "'Josefin Sans', sans-serif",
          fontSize: '0.5rem', letterSpacing: '0.12em', textTransform: 'uppercase',
          color: 'var(--text3)', opacity: 0.5,
          padding: '0.1rem 0 0.4rem', width: '100%', textAlign: 'center',
        }}
      >Privacy &amp; Data</button>
    </nav>
  );
}
